var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status),expression:"status"}],staticClass:"sl-spinner mrg",style:(_vm.spinnerStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }